import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vias-default-dialog-page',
  templateUrl: './default-dialog-page.component.html',
  styleUrls: ['./default-dialog-page.component.scss']
})
export class DefaultDialogPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
